enum ToastType {
  SUCCESS,
  ERROR,
}
export default ToastType;
